import SiteFilterViewModel from "../../TripRate/ViewModels/SiteFilterViewModel";
import { HeaderViewModel } from "./SiteListViewModel";

export default class ExportSiteListViewModel {
    addUserComments: boolean = false;
    userComment: string | null = null;
    displayToScreen: boolean = true;
    fileName: string = "Site List";
    type: "PDF" | "CSV" = "PDF";
    mainUse: string = "";
    subUse: string = "";
    order: string = "";
    orderBy: string = "";
    filter: SiteFilterViewModel | null = null;
    headers: HeaderViewModel[] | null = null;
}